import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {InteractPoDPage, Interacts} from '../../../api/models';
import { AdminInteractiveService } from "../../../api/services";

export interface EditInteractiveDialogData {
  dialogTitle: string;
  interactive: Interacts;
  podPages: InteractPoDPage[];
}

@Component({
  selector: "edit-interactive-dialog",
  styleUrls: ["edit-interactive-dialog.component.css"],
  templateUrl: "./edit-interactive-dialog.component.html",
})
export class EditInteractiveDialogComponent {
  public Result: DialogResult;
  public fileToUpload: File = null;
  public uploadingInteractive: boolean = false;

  public podData: PoDData[] = [];
  public newPageDisplayName: string = "";
  public newPagePage: string = "";

  constructor(
    public dialogRef: MatDialogRef<EditInteractiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditInteractiveDialogData,
    private adminInteractService: AdminInteractiveService
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    data.podPages.forEach(podPage => {
      this.podData.push({
        displayName: podPage.displayName,
        page: podPage.page,
        order: podPage.order
      });
    });
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.uploadingInteractive = true;

    const callParams: AdminInteractiveService.AdminInteractiveEditInteractiveParams = {
      interactiveDescription: this.data.interactive.description,
      interactiveFileId: this.data.interactive.fileId,
      interactiveFileName: this.data.interactive.fileName,
      interactiveFreeInteractive: this.data.interactive.freeInteractive,
      interactiveFreeInteractiveUrl: this.data.interactive.freeInteractiveUrl,
      interactiveInteractId: this.data.interactive.interactId,
      interactiveInteractName: this.data.interactive.interactName,
      interactiveInteractSubContents: [],
      interactiveMarketingUrl: this.data.interactive.marketingUrl,
      interactivePowerBidatasetId: this.data.interactive.powerBidatasetId,
      interactivePowerBidatasetPublishDate: this.data.interactive
        .powerBidatasetPublishDate,
      interactivePowerBiobjectNames: this.data.interactive.powerBiobjectNames,
      interactivePowerBireportId: this.data.interactive.powerBireportId,
      interactivePowerBireportPublishDate: this.data.interactive
        .powerBireportPublishDate,
      interactiveProductUrl: this.data.interactive.productUrl,
      interactiveUdInteractFilters: [],
      interactiveUdModInteractives: [],
      upload: this.fileToUpload,
      interactiveCanModify: this.data.interactive.canModify,
      interactiveCanPreFilter: this.data.interactive.canPreFilter,
      interactivePreFilterCompanyAvailable: this.data.interactive.preFilterCompanyAvailable,
      interactivePreFilterTitleAvailable: this.data.interactive.preFilterTitleAvailable,
      interactivePreFilterRegionAvailable: this.data.interactive.preFilterRegionAvailable,
      interactivePreFilterIndustryAvailable: this.data.interactive.preFilterIndustryAvailable,
      interactivePreFilterOccupationAvailable: this.data.interactive.preFilterOccupationAvailable
    };

    if (this.data.interactive.interactId == -1) {
      this.adminInteractService
        .adminInteractiveCreateInteractive(callParams)
        .subscribe(
          (result) => {

            this.adminInteractService.adminInteractiveUpdateInteractivePrintOnDemandPages({
              interactId: result.interactId,
              pages: this.podData.map(function (podPage) {
                  const podPageData: InteractPoDPage = {
                    interactPoDPageId: 0,
                    interactId: result.interactId,
                    displayName: podPage.displayName,
                    page: podPage.page,
                    order: podPage.order
                  };
                  return podPageData;
                }
              )
            }).subscribe((pagesResult) => {
              this.Result.ResultType = DialogResultType.Ok;
              this.Result.ResultData = null;
              this.dialogRef.close(this.Result);
            });
            }, (error) => {
            alert(error.error);
          });
    } else {
      this.adminInteractService
        .adminInteractiveEditInteractive(callParams)
        .subscribe(
          (result) => {

            this.adminInteractService.adminInteractiveUpdateInteractivePrintOnDemandPages({
              interactId: result.interactId,
              pages: this.podData.map(function (podPage) {
                  const podPageData: InteractPoDPage = {
                    interactPoDPageId: 0,
                    interactId: result.interactId,
                    displayName: podPage.displayName,
                    page: podPage.page,
                    order: podPage.order
                  };
                  return podPageData;
                }
              )
            }).subscribe((pagesResult) => {
              this.Result.ResultType = DialogResultType.Ok;
              this.Result.ResultData = null;
              this.dialogRef.close(this.Result);
            });
          },
          (error) => {
            alert(error.error);
          }
        );
    }
  }

  movePageUp(page: PoDData) {
    var index = this.podData.indexOf(page);
    if (index > 0) {
      var temp = this.podData[index];
      this.podData[index] = this.podData[index - 1];
      this.podData[index - 1] = temp;

      this.podData[index].order = index;
      this.podData[index - 1].order = index - 1;
    }

    return false;
  }

  movePageDown(page: PoDData) {
    var index = this.podData.indexOf(page);
    if (index < this.podData.length - 1) {
      var temp = this.podData[index];
      this.podData[index] = this.podData[index + 1];
      this.podData[index + 1] = temp;

      this.podData[index].order = index;
      this.podData[index + 1].order = index + 1;
    }

    return false;
  }

  removePage(page: PoDData) {
    this.podData.splice(this.podData.indexOf(page), 1);
    this.podData.forEach((podPage, index) => {
      podPage.order = index;
    });

    return false;
  }

  addPage() {
    this.podData.push({
      displayName: this.newPageDisplayName,
      page: this.newPagePage,
      order: this.podData.length
    });

    this.newPageDisplayName = '';
    this.newPagePage = '';

    return false;
  }
}

export class PoDData
{
  public displayName: string;
  public page: string;
  public order: number;
}
